/**
 * Blog posts prev/next for Aero slider.
 * Loaded from sections/blog-posts.liquid as type="module".
 */

const SELECTOR = '[data-section-type="blog-posts"]'

function init(root) {
  if (root.dataset.bpInit) return
  root.dataset.bpInit = 'true'
  if (root.dataset.enableSlider !== 'true') return

  const sliderElement = root.querySelector('[data-blog-posts-slider]')
  const prevButton = root.querySelector('[data-prev]')
  const nextButton = root.querySelector('[data-next]')
  if (!sliderElement || !prevButton || !nextButton) return

  let attempts = 0
  const slides = () => sliderElement.querySelectorAll('.aero-slider__slide:not([data-aero-slider-clone])')
  const slidesPerView = (slider) => {
    const fromCss = parseFloat(getComputedStyle(sliderElement).getPropertyValue('--slides-per-view'))
    if (Number.isFinite(fromCss) && fromCss > 0) return fromCss
    return slider.slidesPerView || 1
  }
  const sync = () => {
    const slider = sliderElement.aeroSlider
    if (!slider) {
      prevButton.disabled = true
      nextButton.disabled = true
      return
    }
    const index = slider.currentIndex ?? 0
    const maxIndex = Math.max(0, Math.floor(slides().length - slidesPerView(slider)))
    prevButton.disabled = index <= 0
    nextButton.disabled = index >= maxIndex
  }
  const poll = () => {
    sync()
    if (sliderElement.aeroSlider || attempts >= 50) return
    attempts += 1
    window.setTimeout(poll, 100)
  }
  prevButton.addEventListener('click', () => sliderElement.aeroSlider && !prevButton.disabled && sliderElement.aeroSlider.prev())
  nextButton.addEventListener('click', () => sliderElement.aeroSlider && !nextButton.disabled && sliderElement.aeroSlider.next())
  sliderElement.addEventListener('aero:slideChange', sync)
  poll()
}

function initAll(scope = document) {
  if (scope.matches?.(SELECTOR)) init(scope)
  scope.querySelectorAll(SELECTOR).forEach(init)
}

initAll()
document.addEventListener('shopify:section:load', (event) => initAll(event.target))
